<!--
create by melody on 2018/11/1
description:用户管理页面
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <div class="search-container">
            <el-form label-width="100px">
                <el-row>
                    <el-col :xl="8" :lg="10" :md="12">
                        <el-form-item :label="$t('m.userName')" style="width: 400px;">
                            <el-input v-model="searchParam.name" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xl="8"  :lg="10"  :md="12">
                        <el-form-item :label="$t('m.roleName')" style="width: 400px;">
                            <el-input v-model="searchParam.roleName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xl="8"  :lg="10"  :md="12">
                        <el-form-item :label="$t('m.enableFlag')" style="width: 400px;">
                            <el-select v-model="searchParam.enableFlag" clearable>
                                <el-option :label="$t('m.enable')" :value="true">
                                </el-option>
                                <el-option :label="$t('m.disable')" :value="false">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="width: 400px;">
                    <lap-search-btn :searchParam="searchParam" @successMethod="getUserList()"></lap-search-btn>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <div class="hdp-uf">
                <el-button type="primary" plain icon="el-icon-plus" @click="handleClick('add')"> {{$t('m.add')}} </el-button>
                <el-button type="info" plain icon="el-icon-delete" @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
                <lap-export-btn class="file-btn" :total="total" :exportType="exportType" :exportUrl="exportAddress"></lap-export-btn>
            </div>
            <el-table
                ref="multipleTable"
                :data="tableData"
                stripe
                tooltip-effect="dark"
                @select="handleSelect"
                @select-all="handleSelect"
                style="width: 100%;margin: 24px 0"
                >
                <el-table-column
                    type="selection">
                </el-table-column>
                <el-table-column
                    type="index">
                </el-table-column>
                <el-table-column
                    :label="$t('m.userAccount')"
                    prop="userAccount"
                    width="120">
                </el-table-column>
                <el-table-column
                    :label="$t('m.userName')"
                    prop="userName"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="userMobile"
                    :label="$t('m.mobileNumber')"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="userEmail"
                    :label="$t('m.email')"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="roleList"
                    :label="$t('m.roleName')"
                    width="120">
                    <template slot-scope="scope">
                        <span>{{scope.row.roleList.length?scope.row.roleList[0].roleName:''}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    prop="orgName"
                    label="组织名称"
                    width="120">
                </el-table-column> -->
                <el-table-column
                    prop="userStartDate"
                    :label="$t('m.startDate')"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="userEndDate"
                    :label="$t('m.endDate')"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="enableFlag"
                    :label="$t('m.enableFlag')">
                    <template slot-scope="scope">
                        <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    width="200"
                    :label="$t('m.operation')">
                    <template slot-scope="scope">
                        <!-- <el-button
                            icon="el-icon-view"
                            plain
                            size="mini"
                            @click="handleClick('view', scope.row)"></el-button> -->
                        <el-button
                            icon="el-icon-edit-outline"
                            plain
                            size="mini"
                            @click="handleClick('modify', scope.row)"></el-button>
                        <el-button
                            icon="el-icon-delete"
                            plain
                            size="mini"
                            type="danger"
                            @click="handleDelete('single',scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="hdp-uf">
                <a href="./static/template/用户配置模板.xlsx">
                    <el-button type="primary" icon="el-icon-download"> {{$t('m.userTemplate')}} </el-button>
                </a>
                <lap-upload-file uploadUrl="/system/user/uploadedUserRoleFile" @successMethod="getUserList()"></lap-upload-file>
            </div>
            <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getUserList()"></lap-pagination>
        </div>
        <el-dialog
            :title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item :label="$t('m.userAccount')" key="1" prop="account" style="width: 100%">
                        <el-input :disabled="operateType!='add'" v-model.trim="form.account" :maxlength="$inputLengthObj.maxLength7"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.userName')" key="2" prop="name" style="width: 100%">
                        <el-input :disabled="operateType=='view'" v-model.trim="form.name" :maxlength="$inputLengthObj.maxLength7"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.mobileNumber')" key="3" prop="mobile" style="width: 100%">
                        <el-input :disabled="operateType=='view'" v-model.trim="form.mobile" :maxlength="15"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.email')" key="4" prop="email" style="width: 100%">
                        <el-input :disabled="operateType=='view'" v-model.trim="form.email" :maxlength="80"></el-input>
                    </el-form-item>
                    <el-form-item v-if="operateType=='add'" key="5" :label="$t('m.password')" prop="password" style="width: 100%">
                        <el-input :disabled="operateType=='view'" auto-complete="new-password" type="password" v-model.trim="form.password" :maxlength="15"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.roleName')" key="6" prop="roleId" style="width: 100%">
                        <el-select v-model="form.roleId" :disabled="operateType=='view'">
                            <el-option
                                v-for="item in roleList"
                                :key="item.roleId"
                                :label="item.roleName"
                                :value="item.roleId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.startDate')" key="7" style="width: 100%">
                        <el-date-picker
                            width="100%"
                            v-model="form.startDate"
                            type="date"
                            :picker-options="pickerOptions0"
                            value-format="yyyy-MM-dd"
                            :disabled="operateType=='view'"
                            :placeholder="$t('m.chooseDate')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('m.endDate')" key="8" style="width: 100%">
                        <el-date-picker
                            width="100%"
                            v-model="form.endDate"
                            type="date"
                            :picker-options="pickerOptions1"
                            value-format="yyyy-MM-dd"
                            :disabled="operateType=='view'"
                            :placeholder="$t('m.chooseDate')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('m.enableFlag')" key="9" prop="enableFlag" style="width: 100%;">
                        <el-radio-group  v-model="form.enableFlag">
                            <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                            <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span v-if="operateType!='view'" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.SYSTEM_MANAGE'),
                thirdTitle: this.$t('m.USER_MANAGE')
            },
            searchParam: {      //查询参数
                name: '',
                roleName: '',
                enableFlag: '',
                pageSize: 10,
                pageNum: 1,
            },
            form: {     //弹框内容
                userId: '',
                account: '',//账户名
                name: '',   //用户名
                email: '',
                mobile: '',
                password: '',
                startDate: '',
                endDate: '',
                roleId: '',
                enableFlag: true
            },
            rules: this.$ruleApi.getRule('user'),
            //开始日期：当前日期后和结束日期后不可勾选
            pickerOptions0: {
                disabledDate: (time) => {
                    let now = new Date()
                    if (this.form.endDate) {
                        let d = new Date(this.form.endDate)
                        return time.getTime() > d.getTime() - 86400000 || time.getTime() < now.getTime() - 86400000
                    } else {
                        return time.getTime() < now.getTime() - 86400000
                    }
                },
            },
            //结束日期：当前日期后和开始日期前不可勾选
            pickerOptions1: {
                disabledDate: (time) => {
                    let now = new Date()
                    if (this.form.startDate) {
                        var d = new Date(this.form.startDate);
                        return time.getTime() < d.getTime() || time.getTime() < now.getTime() - 86400000
                    } else {
                        return time.getTime() < now.getTime() - 86400000
                    }
                }
            },
            tableData: [],  //表数据
            total: 0,   //总数
            dialogVisible: false,   //控制弹框显示与隐藏
            roleList: [],   //选择角色列表
            operateType: '',    //操作类型 add新增 modify修改 view查看
            userIdArr: [],  //批量删除数组
            exportType: '',
            addDisable: false
        }
    },
    computed: {
        exportAddress() {
            //默认没有勾选
            let url
            //勾选
            if(this.userIdArr.length) {
                this.exportType = 'choose' 
                url = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                + '/system/user/exportUser?userIds=' + this.userIdArr
                + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
            } else {
                this.exportType = 'noChoose'
                url = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                + '/system/user/exportUser?name=' + encodeURIComponent(this.searchParam.name)//如果不编码ie会导出失败
                + '&roleName='+ encodeURIComponent(this.searchParam.roleName)
                + '&enableFlag=' + this.searchParam.enableFlag
                // + '&pageSize=' + this.searchParam.pageSize
                // + '&pageNum=' + this.searchParam.pageNum
                + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
            }
            return url
        },

    },
    methods: {
        clickSearch() {
            this.searchParam.pageNum = 1
            this.getUserList()  
        },
        getUserList() {
            this.userIdArr = []
            this.$commonFunc.commonRequest('get', '/system/user/getUserList', 'getUserList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //获取所有角色
        getRoleList() {
            this.$commonFunc.commonRequest('get', '/system/role/getInvalidRoleList')
            .then(res=>{
                this.roleList = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        viewUser(row) {
            this.$commonFunc.commonRequest('get', '/system/user/getDetailUserInfo', 'getDetailUserInfo', {userId: row.userId})
            .then(res=>{
                this.form['userId'] = res.obj.userId
                this.form['account'] = res.obj.userAccount
                this.form['name'] = res.obj.userName
                this.form['email'] = res.obj.userEmail
                this.form['mobile'] = res.obj.userMobile
                this.form['startDate'] = res.obj.userStartDate
                this.form['endDate'] = res.obj.userEndDate
                if(res.obj.roleList.length > 0) {
                    this.form['roleId'] = res.obj.roleList[0].roleId
                }
                this.form['enableFlag'] = res.obj.enableFlag
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addUser() {
            this.$commonFunc.commonRequest('post', '/system/user/addUser', 'addUser', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getUserList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyUser() {
            this.$commonFunc.commonRequest('post', '/system/user/updateUser', 'updateUser', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getUserList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            //如果操作已有数据
            if(row) {
                console.log(row, 350)
                this.form['userId'] = row.userId
                this.form['account'] = row.userAccount
                this.form['name'] = row.userName
                this.form['email'] = row.userEmail
                this.form['mobile'] = row.userMobile
                this.form['startDate'] = row.userStartDate
                this.form['endDate'] = row.userEndDate
                if(row.roleList.length > 0) {
                    this.form['roleId'] = row.roleList[0].roleId
                }
                this.form['enableFlag'] = row.enableFlag
                // this.viewUser(row)
            } else {
                this.form = {
                    userId: '',
                    account: '',
                    name: '',
                    email: '',
                    mobile: '',
                    password: '',
                    startDate: '',
                    endDate: '',
                    roleId: '',
                    enableFlag: true
                }
            }
            this.dialogVisible = true
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addUser()
                    } else {
                        this.modifyUser()
                    }
                } else {
                    return false;
                }
            })
        },
        handleDelete(type,row) {
            if( type == 'batch' && this.userIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                //单个删除
                if(type == 'single') {
                    this.$commonFunc.commonRequest('post', '/system/user/deleteUser', 'deleteUser', {userId: row.userId})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.searchParam.pageNum = 1
                        this.getUserList()
                    })
                //批量删除
                } else {
                    this.$commonFunc.commonRequest('post', '/system/user/batchDeleteUser', 'batchDeleteUser', {userIds: this.userIdArr})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.searchParam.pageNum = 1
                        this.getUserList()
                    })
                    .catch(res=>{
                        this.$message.error(res.message)
                    })
                }
            })
        },
        //处理单选
        handleSelect(row) {
            this.userIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.userIdArr.push(row[i].userId)
                }
            }
        }, 
    },
    mounted() {
        this.getUserList()
        this.getRoleList()
    }
}
</script>
<style scoped>
.file-btn{
  margin-left:10px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%
}
</style>



// WEBPACK FOOTER //
// src/pages/sys/UserManage.vue